import * as React from 'react';
import { Accordion } from 'react-bootstrap';
import { useState, useEffect } from 'react';
import { useAuth } from '../../../Auth';
import { useAxios } from '../../../AxiosHandler';
import { useTranslate } from 'react-polyglot';
import 'react-toastify/dist/ReactToastify.css';
import './Settings.scss';

import ResourceTypes from '../ResourceTypes/ResourceTypes';
import MaintenanceTypes from './MaintenanceType/MaintenanceType';
import SettingsDeal from './SettingsDeal/SettingsDeal';
import SettingsGeneral from './SettingsGeneral';
import SettingsInvoicing from './SettingsInvoicing';

function Settings() {
    const t = useTranslate();  
    const auth = useAuth();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;

    const [updateResources, setUpdateResources] = useState(0);
    
    const [inheriting, setInheriting] = useState(true);
    const [settings, setSettings] = useState();

    function updateLocalstorageSettings(settings) {
        let user = localStorage.getItem("user");
        if (user != null) {
            user = JSON.parse(user);
            if (user != null) {
                user["settings"] = settings;
                localStorage.setItem("user", JSON.stringify(user));
            }
        }
    }

    async function fetchData() {
        axios.all([
            axios.single({
                method: "get",
                url: "/api/settings/byorg/" + auth.user["userdata"]["unit"][0],
                responseType: "json",
                headers: {'x-access-token': auth.user["token"]}
            }),
            axios.single({
                method: "get",
                url: "/api/orgelements/" + auth.user["userdata"]["unit"][0],
                responseType: "json",
                headers: {'x-access-token': auth.user["token"]}
            })
        ])
        .then(axios.spread((...res) => {
            setSettings(res[0].data);
            updateLocalstorageSettings(res[0].data);
            setInheriting(res[1].data[0]["settingsInheritence"]);
        }));
    }

    function handleUpdate(){
        setUpdateResources(updateResources + 1)
    }
    
    useEffect(() => {
        fetchData();
    }, []);

    return(
        <div className="maincontent">
            <div className="systems-container settings">
                <div className="pagetitle-container">
                    <h1>{t("settings.page_name")}{ inheriting ? " " + t("settings.inheritedfrom") : ""}</h1>
                </div>
                <Accordion>
                    <hr/>
                    {/* <SettingsResources /> */}
                    <h3>{t("settings.types_and_deals")}</h3>
                    <ResourceTypes onChange={handleUpdate}/>
                    <SettingsDeal updateTable={updateResources}/>
                    <hr/>
                    <h3>{t("settings.maintainance")}</h3>
                    <MaintenanceTypes />
                    <hr/>
                    <h3>{t("settings.texts")}</h3>
                    <SettingsGeneral
                        settingProps={settings}
                        onSettingsGeneralChanged={ (settings) => {
                            updateLocalstorageSettings(settings);
                        }}
                    ></SettingsGeneral>
                    <h3>{t("settings.invoicing.title")}</h3>
                    <SettingsInvoicing
                        settingProps={settings}
                        onSettingsGeneralChanged={ (settings) => {
                            updateLocalstorageSettings(settings);
                        }}
                    ></SettingsInvoicing>
                </Accordion>
            </div>
        </div>
    );
}

export default Settings;